module.exports = __webpack_public_path__ + "static/maiacontactwhite-bc052189cc7af22df412e040a1d85c65.png";